import React from "react";
import BundlelivestockCard from "./BundlelivestockCard";
import ProductGridHealth from "../ProductGridBelow/ProductGridHealth";

const ProductGrid = ({ handleCardClick }) => {
  return (
    <div className="row mb-2">
      <div className="col-12 mb-3">
        <div
          onClick={() => handleCardClick("API_MIS", "mobile")}
          style={{ cursor: "pointer" }}
        >
          <ProductGridHealth
            image="/images/mobile.png"
            title="Mobile Insurance"
          />
        </div>
      </div>
      <div className="col-3">
        <div
          onClick={() => handleCardClick("API_HIS", "healthinsurance")}
          style={{ cursor: "pointer" }}
        >
          <BundlelivestockCard
            image="/images/health.png"
            title="Health Insurance"
          />
        </div>
      </div>
      <div className="col-3">
        <div
          onClick={() => handleCardClick("API_LIS", "lifestock")}
          style={{ cursor: "pointer" }}
        >
          <BundlelivestockCard
            image="/images/livestock.png"
            title="Livestock Insurance"
          />
        </div>
      </div>
      <div className="col-3">
        <div
          onClick={() => handleCardClick("API_CIS", "crop")}
          style={{ cursor: "pointer" }}
        >
          <BundlelivestockCard
            image="/images/crops.png"
            title="Crop Insurance"
          />
        </div>
      </div>
      <div className="col-3">
        <div
          onClick={() => handleCardClick("API_IP", "incomeprotection")}
          style={{ cursor: "pointer" }}
        >
          <BundlelivestockCard
            image="/images/income.png"
            title="Income Protection"
          />
        </div>
      </div>
      <div className="col-6 mt-3">
        <div
          onClick={() => handleCardClick("API_RSA_BI", "rsabikeinsurance")}
          style={{ cursor: "pointer" }}
        >
          <BundlelivestockCard
            image="/images/bikeimg.png"
            title="RSA Bike Insurance"
          />
        </div>
      </div>
      <div className="col-6 mt-3">
        <div
          onClick={() => handleCardClick("API_RSA_CI", "rsacarinsurance")}
          style={{ cursor: "pointer" }}
        >
          <BundlelivestockCard
            image="/images/carimg.png"
            title="RSA Car Insurance"
          />
        </div>
      </div>
    </div>
  );
};

export default ProductGrid;
